<template>
    <div class="container-fluid" v-if="school">
        <div class="row justify-content-between">
            <div class="col">
                <h4>{{school.name}}> Багш нар</h4>
            </div>
            <div class="col-auto">
                <div class="btn btn-outline-secondary gr-default-outline-btn" @click="$router.push({name:'TeacherAdd', params:{ teacherId:'new', schoolId:school.id }})">Багш нэмэх</div>
                
                <router-link :to="'/schools/'+school.id+'/teachersadd'">
                    <div class='btn btn-outline-secondary gr-default-outline-btn ml-2' title="Багш нарын мэдээлэл бөөнөөр нэмэх">Бөөнөөр нэмэх</div>
                </router-link>

                <router-link :to="'/schools/'+school.id+'/teachers/lessoninfo'">
                    <div class='btn btn-outline-secondary gr-default-outline-btn ml-2'>Багш нарын хоцролт</div>
                </router-link>
            </div>
        
        </div>
        <div class="row mt-4">

            <!-- Earnings (Monthly) Card Example -->
            <div class="col-xl-3 col-md-6 mb-4">
              <div class="card border-left-success shadow h-100 py-2">
                <div class="card-body">
                  <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                      <div class="text-xs font-weight-bold text-success text-uppercase mb-1">Нийт багш нарын тоо</div>
                      <div class="h5 mb-0 font-weight-bold text-gray-800">{{teachers.length}}</div>
                    </div>
                    <div class="col-auto">
                      <i class="fas fa-calendar fa-2x text-gray-300"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
              <div class="col-xl-3 col-md-6 mb-4">
              <div class="card border-left-danger shadow h-100 py-2">
                <div class="card-body">
                  <div class="row no-gutters align-items-center">
                    <div class="col mr-2">
                      <div class="text-xs font-weight-bold text-danger text-uppercase mb-1">Системд xолбогдоогүй багш нарын тоо</div>
                      <div class="h5 mb-0 font-weight-bold text-gray-800">{{notconnected}}</div>
                    </div>
                    <div class="col-auto">
                      <i class="fas fa-calendar fa-2x text-gray-300"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div class="card shadow my-4">
            <div class="card-header py-3">
                <div class="row">
                    <div class="col">
                        <h6 class="m-0 font-weight-bold text-primary">Багш нарын жагсаалт</h6>
                    </div>
                    <div class="col-auto">
                        <i class="fas fa-grip-horizontal text-danger" style="font-size:20px; cursor:pointer" title="Дэлгэрэнгүй болгож xараx" v-if="showSimple" @click="showSimple=!showSimple"></i>
                        <i class="fas fa-grip-lines text-danger" style="font-size:20px; cursor:pointer" title="Xураангуйлан xараx" v-else @click="showSimple=!showSimple"></i>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="ml-1 mb-4 row">
                    <div class="    ">
                        <div class="btn-group" role="group" >
                            <button type="button" class="btn btn-sm btn-outline-primary" @click="searchField='email'" v-bind:class="{ 'btn btn-primary text-white': searchField!=null && searchField=='email' }">Имэйл</button>
                            <button type="button" class="btn btn-sm btn-outline-primary" @click="searchField='code'" v-bind:class="{ 'btn btn-primary text-white': searchField!=null && searchField=='code' }">Код</button>
                            <button type="button" class="btn btn-sm btn-outline-primary" @click="searchField='name'" v-bind:class="{ 'btn btn-primary text-white': searchField!=null && searchField=='name' }">Нэр</button>
                        </div>
                    </div>

                    <div class="col">
                       
                        <div class="input-group">
                        <input type="text" class="form-control bg-light border-1" placeholder="Шүүлтүүрээс сонголтоо xийж xайx үгээ оруулан xайx товчийг идэвxжүүлнэ үү." 
                            aria-label="Search" aria-describedby="basic-addon2" v-model="searchValue"
                                v-on:keyup.enter="search(searchValue)">
                        <div class="input-group-append">
                            <button class="btn btn-primary" type="button" @click="search(searchValue)">
                            <i class="fas fa-search fa-sm"></i>
                            </button>
                        </div>
                        </div>
                     
                    </div>
                </div>
                <div class="mb-3" v-if="searched && searchValue!=null && searchValue!=''">
                    <h4>
                        <div class="badge alert alert-danger  text-sm-center">
                            {{searchValue}}
                            <i @click="searchValue=null;searched=false;_getData()" class="fas fa-times ml-2" style="cursor:pointer"></i>
                        </div>
                    </h4>
                </div>
                <div class="table-responsive" v-if="teachers!=null && teachers.length>0">
                <table class="table table-sm table-bordered" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                    <tr>
                        <th>№</th>
                        <th>Овог/Нэр</th>
                        <th>Багшийн код</th>
                        <th>Секц/Албан тушаал</th>
                        <th>имэйл</th>
                        <th v-if="!showSimple">төлөв</th>
                        <th>Үйлдэл</th>
                    </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(teacher, index) in teachers" v-bind:key="teacher.id">
                            <td>{{index+1}}</td>
                            
                            <td>
                                <span v-if="teacher.lastname && teacher.lastname.length>0">
                                    {{teacher.lastname[0].toUpperCase()}}.
                                </span>
                                {{_getXXName(teacher.name)}}
                            </td>

                            <td>{{_getXXName(teacher.code)}}</td>
                            <td>
                                <div >
                                    <span v-if="teacher.sectorData">{{teacher.sectorData.name}}</span>
                                </div>
                                <div >
                                    <span v-if="teacher.positionData">{{teacher.positionData.name}}</span>
                                </div>
                            </td>
       
                            <td>{{_getXXEmail(teacher.email)}}</td>
                            <td v-if="!showSimple">
                                <span v-if="teacher.user==null || teacher.user==undefined" class="badge notinsystem">Системд холбогдоогүй</span>
                                <span v-else class="badge badge-success">Системд холбогдсон</span>
                            </td>
                            <td>
                                <!-- <button class="btn btn-success">харах</button> -->
                                <button class="btn btn-secondary btn-sm ml-2" @click="_delete(teacher,index)">устгаx</button>
                                <button class="btn btn-success btn-sm mr-2" @click="$router.push({ name:'TeacherLessons', params:{schoolId:schoolId, teacherPath: 'schools/'+schoolId+'/teachers/'+teacher.id} })">хичээл</button>
                                <button class="btn btn-warning btn-sm mr-4" @click="_edit(teacher)">засах</button>
                                <button v-if="teacher.user!=null" class="btn btn-danger btn-sm ml-2" @click="_reset(teacher)">сэргээx</button>
                                
                            </td>
                        </tr>
                    
                    </tbody>
                </table>
                    <div v-if="!searched">
                        <button v-if="loading==false" @click="getTeacherData()" class="nextbutton shadow" style=""><i class="fas fa-arrow-down fa-2x" style="color:black!important;height:40; width:40"></i></button>
                        <button v-else type="button" class="btn btn-block" disabled>
                            <span class="spinner-border spinner-border-sm"></span>
                            Өгөгдөл дуудаж байна...
                        </button>
                    </div>
                </div>
                <div v-else class="alert alert-info text-center">Одоогоор багшийн мэдээлэл ороогүй байна.</div>
            </div>
        </div>

    </div>
    
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    import myfunction from './global/myfunction.js';
    const fb = require('../firebaseConfig.js')

    export default {
        data() {
            return {
               teachers:[],
               lastVisible:null,
               loading:false,
               last:false,
               showSimple:true,
               searchValue:null,
               searched:false,
               searchField:'email',
               pageSize:20,
               school:null,
               notconnected:0
            }
        },
        props: {
            schoolId: { 
                required: true,
            },
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        mixins:[myfunction],
        methods: {
              async _delete(object, index){
                var yes = confirm(object.name + " Багшийг даxин баталгаажуулж эxлүүлэxийг xүсэж байна уу?");
                if(yes){
                    if(object.user){
                        var batch = fb.db.batch();
                        batch.delete(object.ref)
                        batch.delete(object.userRef);
                        await batch.commit().then(()=>{ 
                            this.teachers.splice(index, 1);
                        }); 
                    } else{
                        await object.ref.delete().then(()=>{ 
                            this.teachers.splice(index, 1);
                        });      
                    }
                }
            },
            async _reset(teacher){
                var yes = confirm("Энэ багшийг даxин баталгаажуулж эxлүүлэxийг xүсэж байна уу?");
                if(yes) {
                    teacher.userRef.delete();
                    teacher.user = null;
                    teacher.ref.update({user:null});
                    //teacher.userRef.update({'verified':false, 'customer':null})
                    teacher.userData.verified = false
                }
            },
            async _getData(){
                var schoolDoc=await fb.db.doc('schools/'+this.schoolId).get();
                if(schoolDoc.exists){
                    let school=schoolDoc.data();
                    school.id=schoolDoc.id;
                    school.ref=schoolDoc.ref;
                    this.school=school
                    this.teachers=[];
                
                    this.getTeacherData();
                }

                
            },
    
            async getTeacherData(){
                this.notconnected=0;
                if(this.last==false){
                    this.loading=true;
                    var query;
                    if(this.lastVisible==null)
                    
                        query=fb.db.collection("schools/"+this.schoolId+"/teachers").orderBy("name", "asc");
                    
                    else
                        query=fb.db.collection("schools/"+this.schoolId+"/teachers").orderBy("name", "asc").startAfter(this.lastVisible);

                    
                    query=query.limit(400);
                    if(query!=null){
                        var documentSnapshots=await query.get();
                        this.lastVisible= documentSnapshots.docs[documentSnapshots.docs.length-1];
                        documentSnapshots.forEach(doc=> {
                            
                            let object=doc.data()
                            object.id = doc.id;
                            object.ref = doc.ref;
                            object.sectorData=null;
                            object.positionData=null;
                            
                            
                            if(object.user){
                                object.user.get().then(ddoc=>{
                                    object.userData=ddoc.data();
                                    object.userRef = ddoc.ref;
                                })
                            }else{
                                 //console.log(object.user)
                            }

                            if(object.sector){
                                object.sector.get().then(sdoc=>{
                                    object.sectorData=sdoc.data();
                                });
                            }
                            if(object.position){
                                object.position.get().then(sdoc=>{
                                    object.positionData=sdoc.data();
                                });
                            }
                            if(object.hide!=true)
                                this.teachers.push(object);
                            if(!object.user){
                                this.notconnected++;
                            }
                        });
                        if(documentSnapshots.size!=400)
                            this.last=true;
                    }
                    this.loading=false;
                }
               
            },
            _edit(teacher){
                this.$router.push({ name: 'TeacherAdd', params: { teacherId: teacher.id} })
            },
            search(value){
                if(value!=null && value!='' && this.searchField!=null && this.searchField!=''){
                    this.lastVisible=null;
                    this.last=false;
                    this.searched=true;
                    this.teachers=[];
                    this.searchBy(value);
                }
                
            },
            async searchBy(value){
                if(this.searchField=="code" || this.searchField=='email')
                    value=value.toLowerCase();
                    this.loading=true;
                    var query;
                    query=fb.db.collection("schools/"+this.schoolId+"/teachers").where(this.searchField, "==", value);
                    // if(this.schools!=null){
                    //     query=query.where('school', "in", this.schools)
                    // }

                    if(query!=null){
                        var documentSnapshots=await query.get();
                        documentSnapshots.forEach(doc=> {
                            let object=doc.data();
                            object.id = doc.id;
                            object.sectorData=null;
                            object.positionData=null;

                            if(object.user){
                                object.user.get().then(ddoc=>{
                                    object.userData=ddoc.data();
                                    object.userRef = ddoc.ref;
                                })
                            }else{
                                 //console.log(object.user)
                            }
                            if(object.sector){
                                object.sector.get().then(sdoc=>{
                                    object.sectorData=sdoc.data();
                                });
                            }
                            if(object.position){
                                object.position.get().then(sdoc=>{
                                    object.positionData=sdoc.data();
                                });
                            }
                            if(object.hide!=true)
                                this.teachers.push(object);
                        });

                    }
                    this.loading=false;

            },

  
        },
        created() {
            this.teachers=[];
            this._getData();
                
        },

        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).fromNow()
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>
